import React from "react";

const STYLE = {
  previa: { label: "PRÉVIA", bg: "rgba(255,204,0,0.18)", color: "#FFCC00", border: "rgba(255,204,0,0.5)" },
  final: { label: "FINAL", bg: "rgba(201,168,76,0.22)", color: "#C9A84C", border: "rgba(201,168,76,0.6)" },
  intervalo: { label: "INTERVALO", bg: "rgba(255,255,255,0.08)", color: "#fff", border: "rgba(255,255,255,0.3)" },
};

export const FaseBadge = ({ fase, size = "sm", testId }) => {
  const s = STYLE[fase];
  if (!s) return null;
  const cls = size === "lg" ? "text-sm px-3 py-1" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-testid={testId}
      className={"inline-block font-black tracking-widest align-middle " + cls}
      style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}` }}
    >
      {s.label}
    </span>
  );
};
